const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const formatDateUK = dateInput => {
  if (!dateInput) return 'N/A';

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return 'Invalid Date';

  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  return `${day}-${month}-${year}`;
};

export const formatDateTimeUK = dateInput => {
  if (!dateInput) return 'N/A';

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return 'Invalid Date';

  const day = date.getDate().toString().padStart(2, '0');
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

export const isDatePast = dateInput => {
  if (!dateInput) return false;

  const date = new Date(dateInput);
  const now = new Date();

  date.setHours(0, 0, 0, 0);
  now.setHours(0, 0, 0, 0);

  return date < now;
};

export const formatCurrency = amount => {
  if (amount === null || amount === undefined) return '£0.00';

  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
